import { Navigate, Route, Routes } from 'react-router';
import { AuthProvider, RequireAuth } from './features/auth/auth';
import { LoginPage } from './features/auth/LoginPage';
import { ApplicationsPage } from './features/console/ApplicationsPage';
import { ApprovalsPage } from './features/console/ApprovalsPage';
import { AuditPage } from './features/console/AuditPage';
import { CloudAccountsPage } from './features/console/CloudAccountsPage';
import { ConsoleLayout } from './features/console/ConsoleLayout';
import { EngagementDetailPage } from './features/console/EngagementDetailPage';
import { EngagementsPage } from './features/console/EngagementsPage';
import { FindingsPage } from './features/console/FindingsPage';
import { ReportsPage } from './features/console/ReportsPage';
import { ReportView } from './features/console/ReportView';
import { ExposurePage } from './features/console/ExposurePage';
import { ScopesPage } from './features/console/ScopesPage';
import { SurfaceMapPage } from './features/console/SurfaceMapPage';
import { LandingPage } from './features/marketing/LandingPage';

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/app"
          element={
            <RequireAuth>
              <ConsoleLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="exposure" replace />} />
          <Route path="exposure" element={<ExposurePage />} />
          <Route path="engagements" element={<EngagementsPage />} />
          <Route path="engagements/:id" element={<EngagementDetailPage />} />
          <Route path="engagements/:id/reports/:version" element={<ReportView />} />
          <Route path="findings" element={<FindingsPage />} />
          <Route path="approvals" element={<ApprovalsPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="applications" element={<ApplicationsPage />} />
          <Route path="surface" element={<SurfaceMapPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="scopes" element={<ScopesPage />} />
          <Route path="cloud" element={<CloudAccountsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
